import Vue from "vue";
import BrowserService from "@/core/utils/browser-service";

// イベントログ登録
async function writeLog(logType, screenNm, userAction, count, functionId) {
  const browserInfo = BrowserService.getBrowser(true);
  const dataPost = {
    logType: logType,
    screenName: screenNm,
    userAction: userAction,
    count: count,
    browserName: browserInfo.name,
    browserVer: browserInfo.version,
    os: browserInfo.os,
    screenWidth: browserInfo.screenWidth,
    screenHeight: browserInfo.screenHeight,
    adobeVer: browserInfo.adobeVersion,
    functionId: functionId
  };
  await Vue.axios.post("/kyg000001/event-logs", dataPost, {
    handlerEnabled: false,
    isNotHandlerNetwork: true
  });
}
export default { writeLog };
